<template>
  <div class="strategy-content">
    <!-- 直接显示攻略内容 -->
    <div class="strategy-content" v-if="strategyContent">
      <div v-html="strategyContent"></div>
    </div>
    <!-- 没有攻略数据时显示 -->
    <div class="no-strategy" v-else>
      <p>暂无相关攻略内容</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StrategyContent',
  props: {
    // 接收从父组件传递过来的攻略数据
    strategyContent: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
.strategy-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

.strategy-header {
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.strategy-header h2 {
  margin: 0 0 10px 0;
  color: #333;
  font-size: 1.5rem;
}

.strategy-header p {
  margin: 0;
  color: #666;
}

.strategy-content {
  line-height: 1.8;
  color: #333;
}

.strategy-content p {
  margin-bottom: 15px;
}

.strategy-content h3, .strategy-content h4 {
  margin: 20px 0 10px;
  color: #222;
}

.no-strategy {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  background-color: #f9f9f9;
  border-radius: 4px;
}
</style>
